import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';
import awsConfig from './aws-exports';


Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_region,
    userPoolId: process.env.REACT_APP_userpoolid,
    userPoolWebClientId: process.env.REACT_APP_webclientid,
  }
});

// Amplify.configure({
//   Auth: {
//     region: awsConfig.REGION,
//     userPoolId: awsConfig.USER_POOL_ID,
//     userPoolWebClientId: awsConfig.USER_POOL_APP_CLIENT_ID,
//   }
// });

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
